export const ActionTypes = Object.freeze({
  ANNOTATE_IDS: 'ANNOTATE_IDS',
  ENSURE_FULL_DATA: 'ENSURE_FULL_DATA',
  OVERWRITE_ANNOTATIONS: 'OVERWRITE_ANNOTATIONS',
  REQUEST_ANNOTATE_AESOP_OBJECTS: 'REQUEST_ANNOTATE_AESOP_OBJECTS',
} as const);

export default ActionTypes;
